<template>
  <transition-group name="t-round-items" tag="div">
    <div
      v-if="item" :key="1"
      class="round-item grey600 px-2 py-6" :class="`round-${round}`"
      :style="styles"
    >
      <div
        class="round px-4 py-3 text-h5 text--secondary"
        v-text="round"
      />

      <div
        v-if="item.odds"
        :class="{'show': item.odds <= 0.05}"
        class="item-odds px-3 py-2 text-caption"
      >
        {{ item.odds * 100 | toLocale(4) }}%
      </div>

      <div v-if="!isDud" class="inner text-center">
        <v-img
          :src="`https://community.cloudflare.steamstatic.com/economy/image/${item.image}/164x164`"
          aspect-ratio="1" :width="imageSize" contain
          class="mx-auto mb-4"
        />

        <div
          :style="{color: item.color}"
          class="item-name font-weight-semibold text-truncate text-body-2 text-center mb-1"
          v-text="item.id"
        />
        <div v-if="item.price" class="text-body-2">
          <scrap :amount="item.price" />
        </div>
      </div>
      <div v-else class="inner text-center">
        <v-img
          :src="require('@/assets/img/games/cases/dud.png')"
          aspect-ratio="1" :width="imageSize" contain
          class="mx-auto mb-3 faded-8"
        />

        <h4 class="text-body-1 mb-1 font-weight-bold">
          Dud!
        </h4>
        <p class="text-caption text--disabled lh-1-2 mb-0">
          Well thats embarrassing...
        </p>
      </div>
    </div>
    <div
      v-else :key="2"
      class="round-item is-empty faded-5 d-flex flex-column justify-center bg-ui-panel text-center py-8"
      :class="`round-${round}`"
    >
      <h4 class="text--disabled text-body-2 text-uppercase">
        Round
      </h4>
      <h2 class="text-h4 text--secondary font-weight-bold">
        {{ round > 9 ? round : `0${round}` }}
      </h2>
    </div>
  </transition-group>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    round: {
      type: Number,
      default: 1,
    },
    imageSize: {
      type: Number,
      default: 56,
    },
  },
  computed: {
    styles() {
      const { item } = this
      return {
        '--color': item.color,
      }
    },
    isDud() {
      return this.item.id === 'dud'
    },
  },
}
</script>

<style lang="scss">
.round-item {
  overflow: hidden;
  position: relative;
  height: 100%;
  min-height: 190px; // :)
  transition: transform 0.3s ease, opacity 0.3s ease;

  .round {
    position: absolute;
    z-index: 4;
    top: 0;
    left: 0;
    pointer-events: none;

    &::before {
      position: absolute;
      top: 3px;
      left: 6px;
      opacity: 0.4;
      font-size: 1em;
      font-weight: 300;
      content: '#';
    }
  }

  .item-odds {
    position: absolute;
    z-index: 4;
    top: 0;
    right: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;

    &.show {
      opacity: 0.8;
      text-shadow: 0 2px 8px var(--color);
      font-weight: bold;
    }
  }

  .inner {
    position: relative;
    z-index: 2;
  }

  &::before {
    @include overlay;

    opacity: 0.15;
    background: radial-gradient(circle at top, var(--color) 10%, transparent 65%);
    content: ' ';
    pointer-events: none;
  }

  &:hover {
    .item-odds {
      opacity: 1;
    }
  }
}

.t-round-items {
  &-enter {
    opacity: 0;
    transform: scale(0.5);
  }

  &-enter-to {
    opacity: 1;
    transform: scale(1);
  }

  &-leave-active {
    position: absolute;
    height: auto;

    &.is-empty {
      display: none !important;
    }
  }
}
</style>
